import {useState, useEffect} from 'react'
/** @jsxImportSource @emotion/react */
import {css} from '@emotion/react'

import {connect} from 'react-redux'

import useMediaQuery from '@mui/material/useMediaQuery'

import {useTheme} from '@mui/material/styles'

import {updatePriceFilter, initiateSearch, clearFilter} from '../../actions'


import Slider from '@mui/material/Slider'
import Button from '@mui/material/Button'


import FilterHeader from './FilterHeader'
import FilterFooter from './FilterFooter'



const cssStyles = ({padding, margin, isSmallScreen}) => ({
  root: css`
    width: 100%;
    min-width: ${isSmallScreen ? '100%' : '350px'};
    max-width: 600px;
  `,
  body: css`
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: ${padding ? padding : '40px'};
  `,
  buttonContainer: css`
    margin: ${margin ? margin : '30px 0px 20px 0px'};
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  `,
  button: css`
    text-transform: uppercase;
    font-size: 12px;
    border-radius: 4px;
    max-height: 35px;
    height: 35px;
  `,
  captionContainer: css`
    height: 40px;
    padding-bottom: 20px;
    margin-top: 10px;

    p {
      text-align: center;
    }
  `,
  footerContainer: css`
    width: 100%;
    bottom: 0;
    background-color: #fff;
    z-index: 50
  `
})




const marks = [
  { 
    value: 0,
    label: 'Free'
  },
  { 
    value: 500,
    label: '$$$'
  }
]




function valuetext(value) {
  return value >= 500 ? '∞' : `$${value}`
}


function valueLabelFormat(value) {
  return value >= 500 ? '∞' : `$${value}`
}



const PriceFilter = props => {

  const theme = useTheme()

  const isSmallScreen = useMediaQuery(theme => theme.breakpoints.down('sm'))

  const {
    clearFilter, 
    initiateSearch, 
    updatePriceFilter, 
    price,
    hideHeader,
    hideFooter,
    padding,
    margin,
    callback,
    close
  } = props


  const styles = cssStyles({padding, margin, isSmallScreen})


  const [min, setMin] = useState(price.min)
  const [max, setMax] = useState(price.max)

  const [free, setFree] = useState(false)



  const handlePriceChange = (_, newValue) => {
    const newMin = Math.min(...newValue)
    const newMax = Math.max(...newValue)

    setMin(newMin)
    setMax(newMax)
  }



  useEffect(() => {
    if (callback) {
      callback(min, max)
    }
  }, [min, max, callback])


  useEffect(() => {
    setFree(min === 0 && max === 0)
  }, [min, max])



  function text() {
    if (min === null && max == null) {
      return ''
    }

    if (min === 0 && !max) {
      return 'Free'
    }

    if (min === 0 && max >= 500) {
      return 'Any Price'
    }

    if (min === 0 && max) {
      return `Up to $${max}`
    }

    return `From $${min} to $${max}`
  }



  function toggleFree() {
    if (free) {
      setMin(null)
      setMax(null)
    } else {
      setMin(0)
      setMax(0)
    }

    setFree(!free)
  }



  function apply() {
    if (price.min !== min || price.max !== max) {
      updatePriceFilter([min, max])
      initiateSearch()
      close()
    }
  }



  function clear() {
    setMin(null)
    setMax(null)
    setFree(false)

    // Only initiate a search if the current price filter
    // values are not null since it would yield the same results
    if (price.min !== null || price.max !== null) {
      clearFilter('PRICE')
      initiateSearch()
      close()
    }
  }



  return (
    <div css={styles.root}>
      {!hideHeader && <FilterHeader title='Select Price Range' clear={clear} close={close} />}


      <div css={styles.body}>
        <div css={styles.buttonContainer}>
          <Button 
            css={styles.button} 
            disableElevation 
            onClick={toggleFree} 
            variant='outlined'
            sx={{
              border: free ? '2px solid rgb(62, 166, 255)' : null,
              backgroundColor: free ? 'rgba(62, 166, 255, 0.1)' : '#f5f5f5',

              '&: hover': {
                border: free ? '2px solid rgb(62, 166, 255)' : null,
                backgroundColor: free ? 'rgba(62, 166, 255, 0.1)' : '#f5f5f5'
              } 
            }}
          >
            Free
          </Button>
        </div>

        <Slider
          sx={{
            '& .MuiSlider-thumb': {
              color: theme.palette.pink.main
            }
          }}
          max={500}
          step={5}
          marks={marks}
          value={[min, max]}
          onChange={handlePriceChange}
          valueLabelFormat={valueLabelFormat}
          valueLabelDisplay='auto'
          aria-labelledby='range-slider'
          getAriaValueText={valuetext}
        />

        <div css={styles.captionContainer}>
          <p>{text()}</p>
        </div>
      </div>


      <div css={styles.footerContainer}>
        {!hideFooter && <FilterFooter onClick={apply} />}
      </div>
    </div>
  )
}


const mapStateToProps = state => {
  return {price: state.search.filters.price}
}


const actions = {updatePriceFilter, initiateSearch, clearFilter}


export default connect(mapStateToProps, actions)(PriceFilter)



